var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTutorNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 50,
    height: 50,
    rx: 4,
    fill: "#FEF59B",
    stroke: "#252525",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.48 8.40) scale(0.72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 27.6C28.7576 27.6 33.4251 22.7647 33.4251 16.8C33.4251 10.8353 28.7576 6 23 6C17.2424 6 12.5749 10.8353 12.5749 16.8C12.5749 22.7647 17.2424 27.6 23 27.6Z",
    fill: "#FAC023",
    stroke: "#252525",
    strokeWidth: 2.78,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39 54V42.3344C39 37.1831 34.2199 33 28.3333 33H17.6667C11.7801 33 7 37.1831 7 42.3344V54H39Z",
    fill: "#FAC023",
    stroke: "#252525",
    strokeWidth: 2.78,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7473_16126)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.5 6.44141L50.3543 11.6455L55.5584 14.4998L50.3543 17.3542L47.5 22.5583L44.6457 17.3542L39.4416 14.4998L44.6457 11.6455L47.5 6.44141Z",
    fill: "#FCD82C",
    stroke: "#252525",
    strokeWidth: 2.78,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7473_16126"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white",
    transform: "translate(38 5)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTutorNew);
export default __webpack_public_path__ + "static/media/icon-tutor-new.34901a926a886fe095096c1ad47e54db.svg";
export { ForwardRef as ReactComponent };